export default "__VITE_ASSET__CK7crcaI__"